export default __webpack_public_path__ + "0771da9.png";